import { useEffect, type RefObject } from 'react';
import { hasUserLeftHero } from './homeScrollWarmup';

/**
 * Pauses hero GPU animations when off-screen, tab hidden, or lite mode after scroll-away.
 */
export function useHomeHeroVisibility(
  heroRef: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    let intersecting = true;

    const sync = () => {
      const hidden = document.hidden;
      const away = hidden || !intersecting;
      hero.classList.toggle('home-hero--away', away);
      hero.classList.toggle(
        'home-hero--lite',
        !away && !hidden && intersecting && hasUserLeftHero(),
      );
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        intersecting = Boolean(entry?.isIntersecting);
        sync();
      },
      { threshold: 0.05 },
    );

    observer.observe(hero);
    document.addEventListener('visibilitychange', sync);
    sync();

    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', sync);
    };
  }, [heroRef]);
}
